module.exports = __webpack_public_path__ + "img/cola-light.db32532b.png";